import React from 'react'
// libs
import { useDispatch, useSelector } from 'react-redux'
import { change, formValueSelector } from 'redux-form'
// hooks
import { useModalData } from 'hooks/index'
// components
import Modal from 'components/UI/Modal'
import Header from 'components/UI/Modal/Header'
import SetHoursForm from './SetHoursForm'
// constants
import { Forms, Modals } from 'constants/index'
// utils
import get from 'lodash/get'
import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep'

const selector = formValueSelector(Forms.ACCOUNT_DETAILS_FORM)

const SetDayWorkingHoursModal = () => {
  const dispatch = useDispatch()

  const {
    hideModal,
    modalData: { isOpen, width, key }
  } = useModalData({ modalType: Modals.SET_DAY_WORKING_HOURS_MODAL })

  const businessDays = useSelector((state) => selector(state, 'businessDays'))

  if (!isOpen) {
    return null
  }

  const handleHideModal = () => {
    hideModal()
  }

  const handleSubmit = (data) => {
    const newBusinessDaysData = cloneDeep(businessDays)
    const index = newBusinessDaysData.findIndex((day) => day.value === key)

    if (index !== -1) {
      newBusinessDaysData[index] = {
        ...newBusinessDaysData[index],
        ...data
      }
    }

    dispatch(change(Forms.ACCOUNT_DETAILS_FORM, 'businessDays', newBusinessDaysData))
    handleHideModal()
  }

  const getInitialValues = () => {
    const currentDay = businessDays?.find((day) => day.value === key)

    return {
      startTime: get(currentDay, 'startTime') ? moment(currentDay.startTime) : moment().set({ hour: 9, minutes: 0 }),
      finishTime: get(currentDay, 'finishTime') ? moment(currentDay.finishTime) : moment().set({ hour: 18, minutes: 0 })
    }
  }

  return (
    <Modal hideModal={handleHideModal} isOpen={isOpen} width={width}>
      <Header handleClearClick={handleHideModal}>Business Hours for {key}</Header>
      <SetHoursForm onSubmit={handleSubmit} onCancelClick={handleHideModal} initialValues={getInitialValues()} />
    </Modal>
  )
}

export default SetDayWorkingHoursModal
